import { useEffect } from "react";

import { EntityId } from "@reduxjs/toolkit";

import { Avatar } from "@mui/material";

import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

import { enqueueSnackbar } from "notistack";

import { useLazyGetVideoSnapshotQuery } from "services/streamingApi/streamSnapshot.api";

export interface DeviceThumbnailProps {
    deviceName: string;
    deviceId: EntityId;
    displayErrors: boolean;
    refreshIntervalInMs?: number;
}

export function DeviceThumbnail(props: DeviceThumbnailProps) {
    const [trigger, { data, isFetching, isError }] =
        useLazyGetVideoSnapshotQuery();

    useEffect(() => {
        if (props.displayErrors && isError) {
            enqueueSnackbar(
                `Failed to load video snapshot for device ${props.deviceName}`,
                {
                    variant: "error",
                },
            );
        }
    }, [props.displayErrors, isError, props.deviceName]);

    useEffect(() => {
        trigger(props.deviceId);
    }, [props.deviceId]);

    const handleClick = () => {
        trigger(props.deviceId);
    };

    const isClickable = !isFetching && !data;
    const fallBackIcon = isFetching ? (
        <HourglassBottomIcon />
    ) : (
        <SyncProblemIcon />
    );
    return (
        <Avatar
            variant="square"
            src={data}
            alt={props.deviceName}
            sx={{
                width: 70,
                height: 70,
                cursor: isClickable ? "pointer" : "default",
            }}
            onClick={isClickable ? handleClick : undefined}
        >
            {fallBackIcon}
        </Avatar>
    );
}
